import { IUser } from "../../../types/user/iuser.interface";

export const getUserFullName = (user: IUser) => `${user?.firstName} ${user?.lastName}`;

export const createEmptyUser = (): IUser => ({
  email: "",
  id: 0,
  firstName: "-",
  fullName: "-",
  lastName: "",
  profileImageUrl: "",
  groups: [],
  showBadge: false,
});
